import { useQuery } from "@tanstack/react-query";
import { AdminService } from "../servcies/admin.service";
import { ToastService } from "@shared/lib/services";
import { useEffect } from "react";
import { ADMIN_LIST_QUERY_KEY } from "../constants/";
import { BackednResponse } from "@shared/lib/types";

export function useGetRoles() {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<{
      [key: string]: number;
    }>
  >({
    queryKey: [...ADMIN_LIST_QUERY_KEY, "roles"],
    queryFn: () => AdminService.getRoles(),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    roles: data?.data,
    isError,
    isFetching: isLoading,
  };
}
